module.exports = __webpack_public_path__ + "04_face.35fb4323.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/04_face.png
// module id = Wn1f
// module chunks = 0